if (!customElements.get('alc-teams-modal')) {
    customElements.define(
        'alc-teams-modal',
        class AlcTeamsModal extends ModalDialog {
            constructor() {
                super();
                this.querySelector('#ModalClose-teams-modal-inner')
                    .addEventListener('click', this.hide.bind(this, false));
            }
        }
    );
}